var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgThreeDots({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 6,
    viewBox: "0 0 22 6",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.599609 3.0001C0.599609 1.67461 1.67413 0.600098 2.99961 0.600098C4.32509 0.600098 5.39961 1.67461 5.39961 3.0001C5.39961 4.32558 4.32509 5.4001 2.99961 5.4001C1.67413 5.4001 0.599609 4.32558 0.599609 3.0001Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.59963 3.0001C8.59963 1.67461 9.67415 0.600098 10.9996 0.600098C12.3251 0.600098 13.3996 1.67461 13.3996 3.0001C13.3996 4.32558 12.3251 5.4001 10.9996 5.4001C9.67415 5.4001 8.59963 4.32558 8.59963 3.0001Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5996 3.0001C16.5996 1.67461 17.6741 0.600098 18.9996 0.600098C20.3251 0.600098 21.3996 1.67461 21.3996 3.0001C21.3996 4.32558 20.3251 5.4001 18.9996 5.4001C17.6741 5.4001 16.5996 4.32558 16.5996 3.0001Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThreeDots);
export default __webpack_public_path__ + "static/media/threeDots.effd9917eabd174e03e53588547eefb2.svg";
export { ForwardRef as ReactComponent };